import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export default function CountdownTimer({ resetsAt }) {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!resetsAt) return;

    const calculateTimeLeft = () => {
      const now = new Date();
      const resetTime = new Date(resetsAt);
      const diff = resetTime - now;

      if (diff <= 0) {
        setTimeLeft('now');
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      if (hours > 0) {
        setTimeLeft(`${hours}h ${minutes}m`);
      } else {
        setTimeLeft(`${minutes}m`);
      }
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [resetsAt]);

  if (!timeLeft) return null;

  return (
    <div className="countdown-timer">
      <Clock size={14} />
      <span>Resets in {timeLeft}</span>
    </div>
  );
}
